import axios from 'axios';
import Swal from 'sweetalert2';
export const getCarriers = () => {
    return (dispatch) => {
        axios
            .get('https://api.skypicker.com/carriers')
            .then((data) => {
                dispatch({ type: 'CARRIERS_DATA', payload: data });
            })
            .catch((error) => {
                try {
                    dispatch({
                        type: 'ERROR_MESSAGE',
                        payload: { general: error.response.data.message }
                    });
                } catch {
                    dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
                }
            });
    };
};

export const saveBooking = (data, session_id) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .post(`/flights/save-booking?visitor_uniqid=${session_id}`, data)
                .then((data) => {
                    // Swal.fire({
                    //     position: 'center',
                    //     icon: 'success',
                    //     title: 'Flight booked successfully!',
                    //     timer:2000
                    //   })
                    dispatch({ type: 'SAVE_FLIGHT_BOOKING', payload: data });
                    dispatch({ type: 'CLEAR_PASSENGERS_LIST' });
                    resolve(true);
                })
                .catch((error) => {
                    console.log('Error--->', error)
                    // Swal.fire({
                    //     position: 'center',
                    //     icon: 'error',
                    //     title: 'Something went wrong!',
                    //     timer:2000
                    //   })
                    try {
                        dispatch({
                            type: 'ERROR_MESSAGE',
                            payload: { general: error.response.data.message }
                        });
                    } catch {
                        dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
                    }
                    reject(false);
                });
        })
    };
};

export const saveBookingAirIQ = (data, session_id) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .post('/flights/save-booking-airiq', data)
                .then((data) => {
                    dispatch({ type: 'SAVE_FLIGHT_BOOKING', payload: data });
                    dispatch({ type: 'CLEAR_PASSENGERS_LIST' });
                    resolve(true);
                })
                .catch((error) => {
                    console.log('Error--->', error)
                    try {
                        dispatch({
                            type: 'ERROR_MESSAGE',
                            payload: { general: error.response.data.message }
                        });
                    } catch {
                        dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
                    }
                    reject(false);
                });
        })
    };
};


export const saveHotelBooking = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .post(`/hotels/book-dida`, data)
                .then((data) => {
                    // Swal.fire({
                    //     position: 'center',
                    //     icon: 'success',
                    //     title: 'Flight booked successfully!',
                    //     timer:2000
                    //   })
                    dispatch({ type: 'SAVE_FLIGHT_BOOKING', payload: data });
                    dispatch({ type: 'CLEAR_PASSENGERS_LIST' });
                    resolve(true);
                })
                .catch((error) => {
                    console.log('Error--->', error)
                    // Swal.fire({
                    //     position: 'center',
                    //     icon: 'error',
                    //     title: 'Something went wrong!',
                    //     timer:2000
                    //   })
                    try {
                        dispatch({
                            type: 'ERROR_MESSAGE',
                            payload: { general: error.response.data.message }
                        });
                    } catch {
                        dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
                    }
                    reject(false);
                });
        })
    };
};

